
import { Component, Vue } from "vue-property-decorator";
import IconLogo from "../components/IconLogo.vue";

@Component({ components: { IconLogo } })
export default class LandingView extends Vue {
  get year() {
    return new Date().getFullYear();
  }

  featureColors = [{ icon: "#4f46e5" }, { icon: "#0d9488" }, { icon: "#7c3aed" }, { icon: "#059669" }];

  features = [
    {
      icon: "mdi-format-list-bulleted",
      title: "Term Management",
      description: "Organize all your source strings in one place. Add singular and plural forms with full context control.",
    },
    {
      icon: "mdi-translate",
      title: "Multi-language Support",
      description: "Add as many target languages as you need and track translation completion per language at a glance.",
    },
    {
      icon: "mdi-swap-vertical",
      title: "Import & Export",
      description: "Import your existing JSON files instantly. Export finished translations ready to drop into any project.",
    },
    {
      icon: "mdi-lightning-bolt",
      title: "Simple by Design",
      description: "No bloat, no steep learning curve. Get up and running in minutes and stay focused on building.",
    },
  ];

  steps = [
    {
      title: "Create a project",
      description: "Set up your localization project with a name and source language in seconds.",
    },
    {
      title: "Add terms & languages",
      description: "Define your source strings and add all the target languages your app needs to support.",
    },
    {
      title: "Translate & export",
      description: "Fill in translations and export JSON files ready to use in any framework or platform.",
    },
  ];

  faq = [
    {
      q: "Is it really free?",
      a: "Yes. ParlaEditor is completely free to use — no hidden fees, no trial period, no expiry date.",
    },
    {
      q: "Why is it free?",
      a: "As a solo developer, I needed a simple and affordable way to manage translations for my own apps. ParlaEditor is what I built for myself — and since it's genuinely useful, I'm sharing it with everyone.",
    },
    {
      q: "Do I need a credit card?",
      a: "No. Sign up with just your email. No payment details are ever required.",
    },
    {
      q: "What file formats are supported?",
      a: "JSON is fully supported today. CSV and additional formats are on the roadmap.",
    },
    {
      q: "How many projects, languages, or terms can I create?",
      a: "Unlimited, subject to fair use. We don't impose artificial caps on your projects, languages, or terms.",
    },
    {
      q: "Can I import my existing translations?",
      a: "Yes. Upload your existing JSON files and ParlaEditor will import them into your project instantly.",
    },
    {
      q: "What if you introduce paid plans later?",
      a: "Existing free users keep their current access. If paid plans are ever introduced, you'll never lose what you already have.",
    },
    {
      q: "Is my data secure?",
      a: "Yes. ParlaEditor is built on Supabase, with secure authentication and encrypted data storage.",
    },
    {
      q: "Can I use this with any framework?",
      a: "Absolutely. Export your translations as JSON and use them anywhere — React, Vue, Flutter, iOS, Android, or any platform that reads JSON.",
    },
  ];
}
